<!-- This classes only function is to make sure all text fields have the same base settings applied. Thus sayith the Jacob RawR! -->
<template>
	<v-text-field v-bind="$attrs" :hide-details="'auto'" variant="outlined">
		<!-- Bold the trailing (Required)/(Optional) tag on the label (LSP-16777).
		     Label arrives via $attrs; render through FieldLabel unless a caller supplies its own #label. -->
		<template v-if="$attrs.label && !$slots.label" #label>
			<FieldLabel :label="String($attrs.label)" />
		</template>
		<template v-for="(_, slot) in $slots" #[slot]="scope" :key="slot">
			<slot :name="slot" v-bind="scope || {}"></slot>
		</template>
	</v-text-field>
</template>

<script setup lang="ts">
	import FieldLabel from "@common-ui/components/FieldLabel.vue";
</script>
<!-- TODO: There is a better way to do this in the Vuetify config, but it would apply everywhere to all text fields, and thats too much testing before the 15th. -->
